import React, { useRef, useEffect } from 'react';

const OTPInput = ({
  length = 6,
  value = '',
  onChange,
  className = '',
  error,
  ...props
}) => {
  const inputRefs = useRef([]);

  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  const handleChange = (e, index) => {
    const inputValue = e.target.value;
    
    // Only allow numbers
    if (!/^\d*$/.test(inputValue)) {
      return;
    }

    // Get the last character if multiple characters are pasted
    const char = inputValue.slice(-1);
    
    // Create new OTP value
    const newValue = value.split('');
    newValue[index] = char;
    const finalValue = newValue.join('');
    
    // Update parent component
    onChange(finalValue);

    // Move to next input if current input is filled
    if (char && index < length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace') {
      if (!value[index] && index > 0) {
        // If current input is empty and backspace is pressed, move to previous input
        inputRefs.current[index - 1].focus();
      } else {
        // Clear current input
        const newValue = value.split('');
        newValue[index] = '';
        onChange(newValue.join(''));
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').slice(0, length);
    
    // Only allow numbers
    if (!/^\d*$/.test(pastedData)) {
      return;
    }

    // Update value with pasted data
    onChange(pastedData);

    // Focus the next empty input or the last input
    const nextIndex = Math.min(pastedData.length, length - 1);
    inputRefs.current[nextIndex].focus();
  };

  return (
    <div className="mb-4">
      <div className="flex gap-2 justify-center">
        {Array.from({ length }).map((_, index) => (
          <input
            key={index}
            ref={(el) => (inputRefs.current[index] = el)}
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={1}
            value={value[index] || ''}
            onChange={(e) => handleChange(e, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            onPaste={handlePaste}
            className={`w-12 h-12 text-center text-xl font-semibold rounded-md border ${
              error ? 'border-red-500' : 'border-gray-300'
            } focus:outline-none focus:ring-2 focus:ring-indigo-500/50 focus:border-indigo-500 ${className}`}
            {...props}
          />
        ))}
      </div>
      {error && (
        <p className="mt-1 text-sm text-red-600 text-center">{error}</p>
      )}
    </div>
  );
};

export default OTPInput; 